import { createSlice } from '@reduxjs/toolkit';
import {addYears} from "date-fns";
const initialState = {
    url : "",
    content : null,
    complete : false,
    error : false,
};

const contentSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        onLoad(state) {
            console.log("onload true")
            state.onLoading = true;
        },
        putContent(state, action) {
            state.content = action.payload.content;
            state.url = action.payload.url;
            state.onLoading = false;
        },
        clearContent(state) {
            state.content = null;
            state.url = '';
        },

    },
});

export const { onLoad, putContent, clearContent } = contentSlice.actions;

export default contentSlice.reducer;
